export default "__VITE_ASSET__70c8669d__"